
export class Room {
  id: number = 0;
  address: string = '';
  floor: string = '';
  name: string = '';
  room: string = '';

  public static createFromJson(input: any): Room {
    const data = new Room();
    data.fromJson(input);
    return data;
  }

  fromJson(input: any) {
    this.id = input["id"];
    this.address = input["address"];
    this.floor = input["floor"];
    this.name = input["name"];
    this.room = input["room"];
  }

  toJson(): any {
    return {
      id: this.id,
      address: this.address,
      floor: this.floor,
      name: this.name,
      room: this.room
    };
  }
}
